export const apiUrl = {
  login: 'login',
  getNews: 'News/GetNews',
  getNewsItem: 'News/GetNewsItem',
  getPromos: 'Promos/GetPromos',
  getWholesalerInfo: 'Wholesaler/GetWholesaler',
  getRatecaps: 'Ratecaps/GetRatecaps',
  secureFileUpload: 'File/Upload',
  getResources: 'PageRoutes/GetPage',
  getProducts: 'ProductsWidget/GetProductsWidget',
  selectUserFactor: 'Mfa/SelectUserFactor',
  enrollUserFactor: 'Mfa/EnrollFactor',
  activateFactor: 'Mfa/ActivateFactor',
  resendfactor: 'Mfa/ResendFactor',
  challengeFactor: 'Mfa/ChallengeFactor',
  verifyFactor: 'Mfa/VerifyFactor',
  getUserFactors: 'Mfa/GetUserFactors',
  getUserDetails: 'User/UserDetails',
  getUserProfile: 'User/UserProfile',
  removeUserFactor: 'Mfa/RemoveFactor',
  getFooter: 'Navigation/GetFooter',
  getwholersalerinfo: 'Wholesaler/GetWholesaler',
  userSearch: 'User/UserSearch',
  generateByPassCode: 'InternalTools/GenerateBypassCode',
  clearByPassCode: 'InternalTools/ClearBypassCode',
  getHeaders: 'Navigation/GetHeader',
  getFireLightId: 'AcordFirelight/GetAcordFirelight',
  getSearchResults: 'Search',
  ForgetUserComponent: 'ForgotUsername/GetUsername',
  personalInformationComponent: 'IDP/InitiateUserIDP',
  validatePin: 'IDP/ValidatePin',
  validateSecurityAnswer: 'IDP/ValidateSecurityAnswer',
  forgetUserComponent: 'ForgotUsername/GetUsername',
  validateBypasscode: 'IDP/ValidateBypassCode',
  idpReset: 'IDP/Remove',
  verifyMfaStatus: 'MFA/VerifyMfa',
  getAdvisorList: 'Navigation/GetAdvisorList',
};
